// Styling
import '@sassRoot/entryPoints/base-end.scss';
